var _a, _b;
import { generateActions } from "../generators/generator.actions";
import { EActionState, createCustomAction } from "../utils/action.utils";
import { GENERATOR_PARAMS } from "./payin.constants";
export var getDetailStart = (_a = generateActions(GENERATOR_PARAMS), _a.getDetailStart), getDetailSucceeded = _a.getDetailSucceeded, getDetailFailed = _a.getDetailFailed, getPagedStart = _a.getPagedStart, getPagedSucceeded = _a.getPagedSucceeded, getPagedFailed = _a.getPagedFailed;
var EActionCustom;
(function (EActionCustom) {
    EActionCustom["RefundPayment"] = "REFUND_PAYMENT";
})(EActionCustom || (EActionCustom = {}));
var generateRefundPaymentActions = function () { return ({
    refundPaymentStart: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RefundPayment,
        state: EActionState.Start,
    }),
    refundPaymentSucceeded: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RefundPayment,
        state: EActionState.Success,
    }),
    refundPaymentFailed: createCustomAction({
        entity: GENERATOR_PARAMS.entity,
        custom: EActionCustom.RefundPayment,
        state: EActionState.Fail,
    }),
}); };
export var refundPaymentStart = (_b = generateRefundPaymentActions(), _b.refundPaymentStart), refundPaymentSucceeded = _b.refundPaymentSucceeded, refundPaymentFailed = _b.refundPaymentFailed;
